import React, {PropTypes} from 'react';
import Form, {FormBody, TextInput} from "../../Form";

class StationMetaDataAuditList extends React.Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  }

  componentWillMount() {
    const {audits, slug} = this.props;
    if(!audits) this.context.router.push(slug);
  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {

  }

  render() {
    const {audits} = this.props;
    return (
      <Form>
        <FormBody>
          {audits.map(item => (
            <TextInput label={item.meta_data_name} value={item.value} readOnly/>
          ))}
        </FormBody>
      </Form>
    );
  }
}

export default StationMetaDataAuditList;


// WEBPACK FOOTER //
// ./src/components/Station/MetaData/StationMetaDataAuditList.js